/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_SubmitInputs */

const en_contact_submit = /** @type {(inputs: Contact_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send request`)
};

/**
* | output |
* | --- |
* | "Send request" |
*
* @param {Contact_SubmitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_submit = /** @type {((inputs?: Contact_SubmitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_SubmitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_submit(inputs)
});